import type { SVGProps } from 'react';

const CrossAnalysisIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 4H5C4.44772 4 4 4.44772 4 5V12H32V5C32 4.44772 31.5523 4 31 4ZM4 31V15H12L12 32H5C4.44772 32 4 31.5523 4 31ZM15 35H12H5C2.79086 35 1 33.2091 1 31V5C1 2.79086 2.79086 1 5 1H31C33.2091 1 35 2.79086 35 5V12V15V22V25V31C35 33.2091 33.2091 35 31 35H25H22H15ZM32 22V15H25V22H32ZM25 25H32V31C32 31.5523 31.5523 32 31 32H25V25ZM22 22V15H15V22H22ZM15 25H22V32H15V25Z"
      />
    </svg>
  );
};

export default CrossAnalysisIcon;
